import script from "./hotel-header.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel-header.vue?vue&type=script&setup=true&lang=js"

import "./hotel-header.vue?vue&type=style&index=0&id=1994a064&lang=css"

const __exports__ = script;

export default __exports__